<template>
  <b-navbar toggleable="md" variant="light">
    <b-container>
      <b-navbar-brand :to="{ name: 'home' }">HOME</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav align="start" style="width: 100%">
          <b-nav-item :to="{ name: 'apps' }">
            APPS
          </b-nav-item>
          <b-nav-item :to="{ name: 'notebooks' }">
            NOTEBOOKS
          </b-nav-item>
          <b-nav-item :to="{ name: 'bookNotes' }">
            BOOKNOTES
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>

export default {
  name: 'navbar.vue',
};
</script>

<style scoped>
  .navbar {
    border-bottom: 1px solid gainsboro!important;
    background-color: white!important;
  }
</style>
